import { createFeatureSelector, createSelector } from '@ngrx/store';
import { adapter, DebtAnalysisWidgetConfigurationsState } from '../reducers/debt-analysis-widget-configuration.reducers';

export const selectDebtAnalysisConfigState = createFeatureSelector<DebtAnalysisWidgetConfigurationsState>('debtAnalysisWidgetConfiguration');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors(selectDebtAnalysisConfigState);

export const selectDebtAnalysisWidgetConfiguration = (widgetConfigId: number) => createSelector(selectEntities, (entities) => entities[widgetConfigId]);
export const selectView = (widgetConfigId: number) => createSelector(
  selectDebtAnalysisWidgetConfiguration(widgetConfigId),
  (item) => {
    return (item ? item.View : 'pie');
  });
export const selectGroup1 = (widgetConfigId: number) => createSelector(selectDebtAnalysisWidgetConfiguration(widgetConfigId), (item) => item.GroupByField1);
export const selectGroup2 = (widgetConfigId: number) => createSelector(selectDebtAnalysisWidgetConfiguration(widgetConfigId), (item) => item.GroupByField2);

